const getRangeForElement = (frameDocument, element) => {
  let range = frameDocument.createRange();
  range.selectNodeContents(element);

  //aTag for pdf is a collapsed range so need to move to the section tag that encases the atag. pdfJs adds atags under a section tag in 'annotationLayer' div.
  if (range.collapsed) {
    const parentElement = element.parentElement;

    // if parentElement has more than just the aTag then having SVG on parentElement may cause the svg to bleed into the other unintended siblings elements.
    if (!parentElement && parentElement.childElementCount > 1) {
      console.warn(
        'Cannot find suitable element to create range suitable for rendering SVG.',
      );
      return;
    }
    range.selectNodeContents(parentElement);
    getRangeForElement(frameDocument, parentElement);
  }

  return range;
};

const insertSvgOverElement = (frame, element, id, action = () => {}) => {
  if (!frame || !element) {
    console.warn('No frame or element.');
    return;
  }

  const frameDocument = frame.contentDocument;
  const href = element.getAttribute('href');

  if (!frameDocument || !href) {
    return;
  }

  const temporaryContainer = frameDocument.createElement('div');
  temporaryContainer.innerHTML = `
    <span
        xmlns="http://www.w3.org/1999/xhtml"
        class="svgOverElement svgOverElement-start"
        data-rs-id="svgOverElement-start-${id}"
    ></span>
    <span
        xmlns="http://www.w3.org/1999/xhtml"
        class="svgOverElement svgOverElement-end"
        data-rs-id="svgOverElement-end-${id}"
    ></span>
    <svg
        xmlns="http://www.w3.org/2000/svg" 
        aria-hidden="true"
        class="svgOverElement hiddenSvgOverElement" 
        id="hiddenSvgOverElement-${id}"
    ></svg>
`;

  const startSpanElement = temporaryContainer.querySelector(
    '.svgOverElement-start',
  );
  const endSpanElement = temporaryContainer.querySelector(
    '.svgOverElement-end',
  );

  startSpanElement.setAttribute('data-link-href', href);
  endSpanElement.setAttribute('data-link-href', href);

  let range = getRangeForElement(frameDocument, element);

  if (!range) {
    return;
  }

  if (range.startContainer.nodeType === Node.DOCUMENT_NODE) {
    console.warn(
      'Skipping rendering SVG because the range includes the document itself.',
    );
    return;
  }

  range.insertNode(startSpanElement);
  range.collapse(false);
  range.insertNode(endSpanElement);

  range.startContainer.parentElement?.normalize();
  range.endContainer.parentElement?.normalize();

  range.setStart(startSpanElement, 0);
  range.setEnd(endSpanElement, 0);

  let rects, baseRect;
  try {
    rects = Array.from(range.getClientRects());
    baseRect = range.getBoundingClientRect();
  } catch (e) {
    console.warn('Cant find rect container');
    return;
  }

  if (!rects.length) {
    return;
  }

  if (
    baseRect.width >= frame.scrollWidth &&
    baseRect.height >= frame.scrollHeight
  ) {
    // If aTag is same size or larger than frame, we dont need svg on top of it.

    return;
  }

  const uniqueRects = [...new Set(rects.map((r) => JSON.stringify(r)))].map(
    (r) => JSON.parse(r),
  );

  const svg = temporaryContainer.querySelector(`#hiddenSvgOverElement-${id}`);

  frameDocument.body.parentElement.appendChild(svg);
  svg.style.position = 'absolute';
  svg.style.top = `${baseRect.top}px`;
  svg.style.left = `${baseRect.left}px`;

  svg.setAttribute('width', baseRect.width);
  svg.setAttribute('height', baseRect.height);
  svg.setAttribute('data-link-href', href);

  for (let rect of uniqueRects) {
    if (!rect.width || !rect.height) {
      continue;
    }

    const rectElement = frameDocument.createElementNS(
      'http://www.w3.org/2000/svg',
      'rect',
    );

    rectElement.style.fill = 'transparent';
    rectElement.setAttribute('width', rect.width);
    rectElement.setAttribute('height', rect.height);
    rectElement.setAttribute('x', rect.left - baseRect.left);
    rectElement.setAttribute('y', rect.top - baseRect.top);

    svg.appendChild(rectElement);

    rectElement.addEventListener('click', action);
    rectElement.addEventListener('contextmenu', action);
    rectElement.addEventListener('keypress', (event) => {
      if (event.keyCode === 13) {
        action();
      }
    });
  }
};

export default insertSvgOverElement;
